import { action, makeObservable, observable, reaction } from 'mobx';
import { IOffering } from 'stores/networkInterfaces';
import { IOfferingSearch } from 'utils/globalTypes';
import { thumbnailImage } from 'utils/images';
import { getSingleValue } from 'utils/urlUtils';

import ContentClientStore from './ContentClientStore';
import MarketplaceStore from './MarketplaceStore';

class ActivityStore {
  dealSummaryTab = 0;

  recentSearches: Array<{
    term: string;
  }> = [];

  recentItems: Array<IOfferingSearch> = [];

  constructor(assetBrowsingStore?: MarketplaceStore, contentClientStore?: ContentClientStore) {
    makeObservable(this, {
      recentItems: observable,
      recentSearches: observable,
      dealSummaryTab: observable,

      addRecentItem: action,
      addRecentSearch: action,
      setDealSummaryTab: action
    });

    if (assetBrowsingStore) {
      reaction(
        () => assetBrowsingStore.currentSearch,
        (currentSearch) => {
          if (currentSearch) {
            this.addRecentSearch(currentSearch);
          }
        }
      );
    }

    if (contentClientStore) {
      reaction(
        () => contentClientStore.offeringInfo,
        (offeringInfo) => {
          if (offeringInfo && offeringInfo.id) {
            this.addRecentItem(offeringInfo);
          }
        }
      );
    }
  }

  addRecentSearch(searchTerm: string) {
    if (searchTerm?.length > 0) {
      // remove duplicates
      const recentSearches = this.recentSearches.filter(({ term }) => searchTerm !== term);

      recentSearches.push({ term: searchTerm });

      // keep last 5 searches
      this.recentSearches = recentSearches.slice(-5);
    }
  }

  addRecentItem(offering: IOffering) {
    const recentItem = {
      id: offering.id,
      offering_id: offering.offering_id,
      offering_name: offering.offering_name,
      offering_type: offering.offering_type,
      asset_type: offering.asset_type
    } as IOfferingSearch;

    if (offering.gallery_media) {
      recentItem.gallery_media = [getSingleValue(offering.media)];
    } else if (offering.media) {
      recentItem.gallery_media = [
        { original: thumbnailImage(getSingleValue(offering.media)), title: offering.offering_name }
      ];
    }

    if (
      !recentItem?.id ||
      !recentItem?.offering_id ||
      !recentItem?.offering_name ||
      !recentItem?.gallery_media
    ) {
      return;
    }

    // remove duplicates
    const recentItems = this.recentItems.filter((item) => item.id !== recentItem.id);

    recentItems.push(recentItem);

    // keep last 5 searches
    this.recentItems = recentItems.slice(-5);
  }

  setDealSummaryTab(selectedTab: number) {
    this.dealSummaryTab = selectedTab;
  }
}

export default ActivityStore;
